import React from 'react';
import _ from 'lodash';

import errorController from 'Components/ErrorScreens';
import RouteLoading from 'Components/RouteLoading';
import useGetSingleListAndSetBreadcrumb from '../hooks/useGetSingleListAndSetBreadcrumb';

import Importer from './components/Importer';

const ListEntriesImport = () => {
    const { listId, query: singleListAPI } = useGetSingleListAndSetBreadcrumb();
    const { hasError, errorCmp } = errorController([singleListAPI.error]);

    if (singleListAPI.isLoading || singleListAPI.isFetching) {
        return <RouteLoading />;
    }

    if (hasError || !singleListAPI.data || _.isEmpty(singleListAPI.data)) return errorCmp;
    const listType = singleListAPI.data.listType as SingleListType;
    return (
        <Importer
            listName={singleListAPI.data.name}
            listType={listType}
            listId={listId}
            merchantSpecific={singleListAPI.data.merchantSpecific}
        />
    );
};

export default ListEntriesImport;
